require("!!C:\\ixs\\Source\\ng_ PKUS\\node_modules\\script-loader\\addScript.js")(require("!!C:\\ixs\\Source\\ng_ PKUS\\node_modules\\raw-loader\\index.js!C:\\ixs\\Source\\ng_ PKUS\\node_modules\\ng2-toastr\\bundles\\ng2-toastr.min.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./~/ng2-toastr/bundles/ng2-toastr.min.js
// module id = 755
// module chunks = 324